import { configureStore } from '@reduxjs/toolkit';
// import glassTypeReducer from './slices/configGlassSlice';
// import configureSizeReducer from '../redux/reducers/configureSizeReducer';
import basketReducer from './slices/configBasketSlice';
import quoteReducer from './slices/configQuoteSlice';
import siteReducer from './slices/configSiteSlice';
import siteCompReducer from './slices/configSiteSliceCompact';
import gymCompReducer from './slices/configGymSlice';
import surveyReducer from './slices/configSurveySlice';

export const store = configureStore({
  reducer: {
    // configGlass: glassTypeReducer, // Not used in Gym
    // configSize: configureSizeReducer, // Not used in Gym
    basket: basketReducer,
    gym: gymCompReducer,

    survey: surveyReducer,
    quote: quoteReducer,
    site: siteReducer,
    siteComp: siteCompReducer,
  },
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware()],

  devTools: process.env.NODE_ENV !== 'production',
});
